<div class="speed-dial">
    <!-- Main FAB button with rotate animation -->
    <button class="fab" (click)="toggleDial()" >
      <img *ngIf="!isDialOpen" class="feb-img"  src="https://res.cloudinary.com/afterbricks/image/upload/v1731505014/unnamed_jj6kua.png" alt="">
      <img *ngIf="isDialOpen" class="feb-img" style="width: 14px !important;
    height: 14px !important;"  src="https://res.cloudinary.com/afterbricks/image/upload/v1732700629/close_1_tdnrc4.png" alt="">
      <!-- <span *ngIf="!isDialOpen"> <img class="feb-img" scr=""></span>
      <span *ngIf="isDialOpen"><img class="feb-img" src=""></span> -->
      <!-- <span *ngIf="!isDialOpen"> <i class="pi pi-plus"></i> </span> -->
      <!-- <span *ngIf="isDialOpen"><i class="pi pi-times"></i></span> -->
    </button>
  
    <!-- FAB options with appearance animation -->
    <div class="fab-options" *ngIf="isDialOpen" [@optionAppear]>
      <a href="https://wa.me/{{phoneNumber}}" target="_blank">
        <button class="fab-option whatsapp">
          <img src="assets/icons/whatsapp.png" alt="WhatsApp" />
        </button>
      </a>
      <a href="tel:{{phoneNumber}}">
        <button class="fab-option call">
          <img src="assets/icons/phone-call.png" alt="Call" />
        </button>
      </a>
    </div>
  </div>